<template>
  <div class="skeleton-list-container">
    <div class="skeleton-banner skeleton-animation" v-if="!onlySkeletonList"/>
    <div class="skeleton-tab skeleton-animation" v-if="!onlySkeletonList" />
    <div class="skeleton-job-item flex-start" v-for="item in skeletonNumber" :key="item">
      <div class="skeleton-image skeleton-animation" />
      <div class="flex-column skeleton-info">
        <div class="flex-between">
          <div class="skeleton-title skeleton-animation" />
          <div class="skeleton-btn skeleton-animation" />
        </div>
        <div class="skeleton-child-info skeleton-animation" />
        <div class="skeleton-child-info skeleton-animation" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'skeleton-list',
    props: {
      skeletonNumber: {
        type: Number,
        default: 5
      },
      onlySkeletonList: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    mounted() {
    },
    computed: {},
    watch: {},
    components: {},
    methods: {}
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .skeleton-list-container {
    padding: 12px 16px 0;
    * {
      border-radius: 4px;
    }
    .skeleton-banner {
      height: 136px;
    }
    .skeleton-tab {
      width: 72px;
      height: 26px;
      margin: 24px 0 6px;
      /*height: 100vh;*/
    }
    .skeleton-image {
      width: 58px;
      height: 58px;
      border-radius: 6px;
      margin-right: 12px;
    }
    .skeleton-info {
      padding: 20px 0;
      flex: 1;
      height: 98px;
      border-bottom: 1px solid #F4F4F4;
      * {
        height: 16px;
      }
      .skeleton-title {
        width: 190px;
      }
      .skeleton-btn {
        width: 50px;
      }
      .skeleton-child-info {
        width: 134px;
        margin-top: 6px;
      }
    }
  }
</style>